import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Height of the fixed site header, so anchored sections are not hidden behind it. */
const HEADER_OFFSET = 96;

/**
 * Keeps in-page anchor navigation working now that internal links use the router
 * (`<Link to="/calendar#list-event">`) instead of full page reloads.
 *
 * Content is often loaded asynchronously, so the target may not exist on the
 * first frame — it retries briefly before giving up.
 */
export default function HashScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    let timer = 0;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
        window.scrollTo({ top, behavior: 'smooth' });
        return;
      }
      attempts += 1;
      if (attempts < 10) {
        timer = window.setTimeout(tryScroll, 120);
      }
    };

    tryScroll();
    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}